import React, {useContext, useMemo} from 'react'
import moment from 'moment'
import {sidebarDisplayMeta} from './constants'
import {Grid} from '@material-ui/core'
import {ReservationCalendarMainContext} from '../../context/ReservationCalendarMain'
import {hexToRgbA} from '../ReservationNewCalendar/MonthView/EventItem'

export const SidebarEvent = ({
  dateObj,
  key,
  start_field,
  end_field,
  selectedDate,
  onClickEvent,
}) => {
  const {isSameDate, navigatedDate, realSearch} = useContext(ReservationCalendarMainContext)
  function getHighlightedText(text, highlight) {
    // Split text on highlight term, include term itself into parts, ignore case
    const parts = !!highlight ? text.split(new RegExp(`(${highlight})`, 'gi')) : [text]
    return (
      <>
        <div className="normal_font">
          {' '}
          {parts.map((part, i) => (
            <span
              key={i}
              style={
                part.toString().toLowerCase() === highlight.toLowerCase()
                  ? {backgroundColor: '#ffef5b'}
                  : {}
              }
            >
              {part}
            </span>
          ))}{' '}
        </div>
      </>
    )
  }

  const displayDateTime = (dateObj, start_field, end_field) => {
    if (isSameDate(dateObj[start_field], dateObj[end_field])) {
      return `${moment(dateObj[start_field]).format('h:mm a')} - ${moment(
        dateObj[end_field]
      ).format('h:mm a')}`
    } else {
      return `${moment(dateObj[start_field]).format('MMMM Do')} - ${moment(
        dateObj[end_field]
      ).format('MMMM Do')}`
    }
  }

  const rectangleStyling = useMemo(() => {
    let store = ''
    if (dateObj.state !== 'pending' || dateObj.status === 'fulfilled') {
      store = 'Rectangle-140'
      return store
    } else {
      store = 'Rectangle-135'
      return store
    }
  }, [dateObj.status, dateObj.state])

  const rectangleBgColor = dateObj.bgColor
  const dataState = dateObj.state === 'pending'
  return (
    <Grid
      item
      md={12}
      className={`btn_cursor ${rectangleStyling}`}
      onClick={() => onClickEvent(dateObj)}
      style={
        dataState
          ? {
              border: `dashed 2px ${rectangleBgColor}`,
              backgroundColor: hexToRgbA(rectangleBgColor, 0.1),
            }
          : {
              border: `solid 1px ${rectangleBgColor}`,
              borderLeft: `solid 4px ${rectangleBgColor}`,
              backgroundColor: hexToRgbA(rectangleBgColor, 0.1),
            }
      }
    >
      {sidebarDisplayMeta[dateObj.type]?.fields?.map(field =>
        field === 'date' ? (
          <p className="normal_font">{displayDateTime(dateObj, start_field, end_field)}</p>
        ) : ['reservation_uid', 'reserved_for', 'display_name'].includes(field) &&
          dateObj[field] &&
          getHighlightedText(dateObj[field], realSearch) ? (
          getHighlightedText(
            `${field === 'reservation_uid' ? '#' : ''}${dateObj[field]}`,
            realSearch
          )
        ) : (
          <>
            <p className="normal_font">{dateObj[field]}</p>
          </>
        )
      )}
    </Grid>
  )
}
